import { jsonObject, jsonMember, jsonArrayMember } from "typedjson";

// OutPointLike
@jsonObject
export class OutPointLike {
  @jsonMember(String)
  tx_hash!: string;

  @jsonMember(String)
  index!: string;
}

// ScriptLike
@jsonObject
export class ScriptLike {
  @jsonMember(String)
  code_hash!: string;

  @jsonMember(String)
  hash_type!: "type" | "data" | "data1" | "data2";

  @jsonMember(String)
  args!: string;
}

// CellDepLike
@jsonObject
export class CellDepLike {
  @jsonMember(OutPointLike)
  out_point!: OutPointLike;

  @jsonMember(String)
  dep_type!: "dep_group" | "code";
}

// CellInputLike
@jsonObject
export class CellInputLike {
  @jsonMember(OutPointLike)
  previous_output!: OutPointLike;

  @jsonMember(String)
  since!: string;
}

// CellOutputLike
@jsonObject
export class CellOutputLike {
  @jsonMember(String)
  capacity!: string;

  @jsonMember(ScriptLike)
  lock!: ScriptLike;

  @jsonMember(ScriptLike, { isRequired: false })
  type?: ScriptLike | null;
}

// ScriptGroup
@jsonObject
export class ScriptGroup {
  @jsonMember(ScriptLike)
  script!: ScriptLike;

  @jsonMember(String)
  group_type!: "lock" | "type";

  @jsonArrayMember(String)
  input_indices!: string[];

  @jsonArrayMember(String)
  output_indices!: string[];
}

// TransactionLike
@jsonObject
export class TransactionLike {
  @jsonMember(String)
  version!: string | number;

  @jsonMember(String)
  hash!: string;

  @jsonArrayMember(CellDepLike)
  cell_deps!: CellDepLike[];

  @jsonArrayMember(String)
  header_deps!: string[];

  @jsonArrayMember(CellInputLike)
  inputs!: CellInputLike[];

  @jsonArrayMember(CellOutputLike)
  outputs!: CellOutputLike[];

  @jsonArrayMember(String)
  outputs_data!: string[];

  @jsonArrayMember(String)
  witnesses!: string[];
}

// TransactionWithScriptGroups
@jsonObject
export class TransactionWithScriptGroups {
  @jsonMember(TransactionLike)
  tx_view!: TransactionLike;

  @jsonArrayMember(ScriptGroup)
  script_groups!: ScriptGroup[];
}

@jsonObject
export class Transaction {
  @jsonMember(String)
  version!: string | number;

  @jsonMember(String)
  hash!: string;

  @jsonArrayMember(CellDepLike)
  cell_deps!: CellDepLike[];

  @jsonArrayMember(String)
  header_deps!: string[];

  @jsonArrayMember(CellInputLike)
  inputs!: CellInputLike[];

  @jsonArrayMember(CellOutputLike)
  outputs!: CellOutputLike[];

  @jsonArrayMember(String)
  outputs_data!: string[];

  @jsonArrayMember(String)
  witnesses!: string[];

  constructor(
    version: string | number,
    hash: string,
    cell_deps: CellDepLike[],
    header_deps: string[],
    inputs: CellInputLike[],
    outputs: CellOutputLike[],
    outputs_data: string[],
    witnesses: string[],
  ) {
    this.version = version;
    this.hash = hash;
    this.cell_deps = cell_deps;
    this.header_deps = header_deps;
    this.inputs = inputs;
    this.outputs = outputs;
    this.outputs_data = outputs_data;
    this.witnesses = witnesses;
  }
}
